import React, { useEffect } from "react";
import InvoiceQueueTab from "./tabs/invoice-queue-tab/InvoiceQueueTab";
import ResourceEarningsTab from "./tabs/resource-earning-tab/ResourceEarningsTab";
import AwaitingAllocationTab from "./tabs/awaiting-allocation-tab/AwaitingAllocationTab";
import usePersistedState from "../../utils/usePersistedState";

const tabsList = [
  { id: "invoice-queue", label: "Invoice Queue" },
  { id: "resource-earnings", label: "Resource Earnings" },
  { id: "awaiting-allocation", label: "Awaiting Allocation" },
];

const ResourceEarning = () => {
  // Persist active tab and viewing invoice across page refreshes
  const [activeTab, setActiveTab] = usePersistedState("re_active_tab", "invoice-queue");
  const [viewingInvoice, setViewingInvoice] = usePersistedState("re_viewing_invoice", null);

  useEffect(() => {
    if (activeTab === "exceptions") {
      setActiveTab("invoice-queue");
    }
  }, [activeTab, setActiveTab]);

  return (
    <div className="bg-white p-3 detailpage resource-earning-page">
      {/* Top Navigation Tabs - hidden when viewing contract details */}
      {!viewingInvoice && (
        <ul
          className="nav nav-tabs resource-earning-tabs"
          id="resourceEarningTabs"
          role="tablist"
          style={{ marginBottom: "10px" }}
        >
          {tabsList.map((tab) => (
            <li key={tab.id} className="nav-item pe-4" role="presentation">
              <button
                type="button"
                className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      )}

      {/* Tab Content */}
      <div className="re-tab-content">
        {activeTab === "invoice-queue" && (
          <InvoiceQueueTab
            viewingInvoice={viewingInvoice}
            setViewingInvoice={setViewingInvoice}
          />
        )}
        {activeTab === "resource-earnings" && <ResourceEarningsTab />}
        {activeTab === "awaiting-allocation" && (
          <AwaitingAllocationTab
            setActiveTab={setActiveTab}
            setViewingInvoice={setViewingInvoice}
          />
        )}
      </div>
    </div>
  );
};

export default ResourceEarning;
